export function redirectToConnect() {
  // Navigate to Connect app
  window.location.assign(window.location.origin);
}

// TODO: improve this to redirect to the correct page depending on the country
export function goToTwBusiness(): void {
  window.location.href = 'https://www.treatwell.fr/partenaires';
}
